import { RSAA } from 'redux-api-middleware';
import { userAccountPropertiesSelector as propertiesSelector } from '../selectors/properties';
import { userAccountIsUnauthenticatedSelector as isUnauthenticatedSelector } from '../selectors/isUnauthenticated';
import { LOGIN_WITH_TOKEN } from './types';

const paramsToHeaders = ({ token }) => ({
  Authorization: `Bearer ${token}`,
});

const requestApiAction = (params) => ({
  [RSAA]: {
    endpoint: '/v3/session',
    method: 'GET',
    credentials: 'include',
    headers: paramsToHeaders(params),
    types: [
      LOGIN_WITH_TOKEN.REQUEST,
      {
        type: LOGIN_WITH_TOKEN.SUCCESS,
        payload: async (action, state, res) => {
          const data = await res.json();
          if (Object.keys(data.user).length === 0) {
            throw new Error('User not found');
          }
          const { user, preferences } = data;
          return {
            ...user,
            preferences,
          };
        },
      },
      LOGIN_WITH_TOKEN.FAILURE,
    ],
  },
});

export const userAccountLoginWithStoredTokenThunkAction = () => (dispatch, getState) => {
  const state = getState();
  const isUnauthenticated = isUnauthenticatedSelector(state);
  const { accessToken } = propertiesSelector(state);

  if (isUnauthenticated && accessToken) {
    return dispatch(requestApiAction({ token: accessToken }));
  }

  return null;
};
